import { PsychiatricIcon } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../../translations';

import { ModuleChip } from './base/ModuleChip';

const t = dashboardTranslationKeys.psychiatricModule;

export const PsychiatricModuleChip = (): JSX.Element => {
   return <ModuleChip label={t.psychiatry} icon={<PsychiatricIcon />} testId={'psychiatricModuleChip'} />;
};
